module.exports = __webpack_public_path__ + "img/gauge-low.fc06eb6d.svg";